import { createContext } from "react";
import firebase from "firebase/compat/app";
import { Alert } from "./themes-views/system-design/DSAlert";

export type Role = { role: "admin" | "editor" | "clock" };
export type AppContextProps = {
  user: firebase.User & Role;
  alert: Alert | undefined;
  showAlert: (alert: Alert | undefined) => void;
};

const AppContext = createContext<AppContextProps>({} as AppContextProps);

export default AppContext;
